import Cookies from "js-cookie";

/**
 * Global fetch interceptor for token expiration and 401 Unauthorized handling.
 * Automatically clears user auth cookies and redirects to "/" if token is expired/invalid.
 */
let isRedirecting = false;

export const initAuthInterceptor = () => {
  if (typeof window === "undefined" || window._authInterceptorInitialized) return;
  window._authInterceptorInitialized = true;

  // 🔹 Handle Admin "Login as Member" SSO token transfer via URL parameter
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const adminToken = urlParams.get("adminToken") || urlParams.get("ssoToken");
    if (adminToken) {
      const jsonToken = JSON.stringify(adminToken);
      Cookies.set("authTokenUserLogin", jsonToken, { expires: 7, path: "/" });
      Cookies.set("authTokenUser", jsonToken, { expires: 7, path: "/" });

      // Clean query parameter from URL bar
      urlParams.delete("adminToken");
      urlParams.delete("ssoToken");
      const newSearch = urlParams.toString();
      const cleanUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "") + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  } catch (err) {
    console.error("SSO Token init error:", err);
  }

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    if (response.status === 401 && !isRedirecting) {
      const hasAuthCookie = Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser");

      if (hasAuthCookie) {
        isRedirecting = true;
        Cookies.remove("authTokenUserLogin");
        Cookies.remove("authTokenUser");
        sessionStorage.clear();

        window.location.href = "/";
      }
    }

    return response;
  };
};
